export default {
  /**
   * Obtener la ruta actual del state
   */
  getRoute: state => () => state.route,
  /**
   * Obtener la respuesta mockeada
   */
  getMock: state => () => state.mock,
  /**
   * Obtener la ruta actual del state
   */
  getIsExceeded: state => () => state.isExceeded,
  /**
   * Obtener el model + datos del paso 1
   */
  getPaso1: state => () => state.paso1,
  /**
   * Obtener el model + datos del paso 2
   */
  getPaso2: state => () => state.paso2,
  /**
   * Obtener el model + datos del paso 3
   */
  getPaso3: state => () => state.responseOferta.respuesta.oferta,
  /**
   * Obtener el model + datos del paso 4
   */
  getPaso4: state => () => {
    let { paso1 } = state;
    let datosPrecargados = {
      phone: { area: paso1.phone.area, numero: paso1.phone.numero },
      email: paso1.email
    };

    return { ...state.paso4, ...datosPrecargados };
  },
  /**
   * Obtener el model + datos de gracias
   */
  getGracias: state => () => ({
    nombre: state.responseConfirmacion.respuesta.datosTurnos.nombre,
    fecha: state.responseConfirmacion.respuesta.datosTurnos.fecha,
    sucursal: state.responseConfirmacion.respuesta.datosTurnos.sucursal,
    razonSocial: state.responseConfirmacion.respuesta.datosTurnos.razonSocial,
    cuit: state.responseConfirmacion.respuesta.datosTurnos.cuitFormateado
  }),

  getSucursales: state => () => state.sucursales,
  getDatosPersonales: state => () => state.datosPersonales,
  getDatosSucursal: state => () => state.datosSucursal,
  getTiposTramite: state => () => state.tiposTramite,
  getFechaTurno: state => () => state.fechaTurno,
  getHoraTurno: state => () => state.horaTurno,
  getGraciasPersonas: state => () => state.graciasPersonas,
  getTurnoAgendado: state => () => state.turnoAgendado
};
